// src/pages/jobs/JobDetails.jsx

import React from "react";

const JobDetails = ({ job, onBack }) => {
  return (
    <div
      className="p-4"
      dir="rtl"
      style={{ maxWidth: "800px", margin: "auto" }}
    >
      <h3 className="mb-2 fw-bold">{job.title}</h3>
      <p
        className="text-primary mb-4"
        style={{ fontSize: "1.05rem", lineHeight: "1.8" }}
      >
        {job.program} / {job.department}
      </p>

      <p
        style={{
          fontSize: "1.1rem",
          lineHeight: "1.9",
          marginBottom: "1.5rem",
        }}
      >
        {job.description}
      </p>

      <ul
        className="mt-3 mb-4"
        style={{ fontSize: "1.05rem", lineHeight: "1.8" }}
      >
        <li>
          <strong>درجه تحصیلی مورد نیاز:</strong> {job.level}
        </li>
        <li>
          <strong>تعداد بست خالی:</strong> {job.vacancies}
        </li>
        <li>
          <strong>محل وظیفه:</strong> {job.province}
        </li>
      </ul>

      <h5 className="mt-4 mb-2 fw-semibold">طرزالعمل درخواست</h5>

      <p
        style={{ fontSize: "1.05rem", lineHeight: "1.8", marginBottom: "1rem" }}
      >
        اعلان بست های کادری پوهنتون میوند! استادان و اعضای کادر علمی ستون اساسی
        تحصیل و تحقیق در یک نهاد تحصیلی هستند. بدون فعالیت منظم و بنیادین این
        بخش، رسیدن به هدف و ارائه خدمات تحصیلی با کیفیت و پایدار ممکن نیست.
      </p>

      <p
        style={{ fontSize: "1.05rem", lineHeight: "1.8", marginBottom: "1rem" }}
      >
        پوهنتون میوند با استفاده از فرصت پیش آمده جهت جذب استادان نخبه و تکمیل
        کادر علمی دائمی، استخدام (۱۶) بست اعضای کادر علمی خویش را اعلان
        می‌نماید. کاندیدان محترم می‌توانند با استفاده از رهنمایی ذیل جهت شمولیت
        در این پروسه اقدام نمایند.
      </p>

      <p
        style={{ fontSize: "1.05rem", lineHeight: "1.8", marginBottom: "1rem" }}
      >
        مدارک مورد نیاز:
        <ul style={{ marginTop: "0.5rem", paddingInlineStart: "1.2rem" }}>
          <li>تکمیل فورم درخواستی کادر علمی</li>
          <li>کاپی رنگه تزکره</li>
          <li>کاپی رنگه اسناد تحصیلی (دیپلوم و ترانسکرپت به زبان ملی)</li>
          <li>کاپی مکتوب قوای بشری در صورت اسناد بیرون مرزی</li>
          <li>دو قطعه عکس ۳×۴</li>
        </ul>
      </p>

      <p
        style={{ fontSize: "1.05rem", lineHeight: "1.8", marginBottom: "1rem" }}
      >
        نوت: کاندیدانیکه بصورت آنلاین درخواست می‌دهند، اسنادشان را در یک فایل
        PDF جمع‌آوری و به آدرس ایمیل زیر ارسال نمایند:
      </p>

      <strong
        style={{ display: "block", marginBottom: "1rem", fontSize: "1.05rem" }}
      >
        hr@maiwand.edu.af
      </strong>

      <p
        style={{ fontSize: "1.05rem", lineHeight: "1.8", marginBottom: "1rem" }}
      >
        شماره های تماس: ۰۷۶۶۹۰۵۰۰۷ / ۰۷۸۶۹۰۵۰۰۸
      </p>

      <p
        style={{ fontSize: "1.05rem", lineHeight: "1.8", marginBottom: "1rem" }}
      >
        مهلت ثبت نام: ۱۴۰۴/۱۰/۱۶ الی ۱۴۰۴/۱۰/۲۶
      </p>

      <p
        className="text-muted"
        style={{ lineHeight: "1.6", marginBottom: "1.5rem" }}
      >
        یادداشت: برای هر بست یک کتاب یا اثر علمی به عنوان منبع امتحان تخصصی در
        نظر گرفته شده است. برای معلومات بیشتر به صفحات اجتماعی وزارت تحصیلات
        عالی مراجعه نمایید.
      </p>

      <p
        style={{ fontSize: "1.05rem", lineHeight: "1.8", marginBottom: "2rem" }}
      >
        تمامی متقاضیان می‌توانند CV، فورم تکمیل شده و یا هرگونه پرسش و استعلام
        خود را به ایمیل آدرس <strong>hr@maiwand.edu.af</strong> ارسال نمایند.
      </p>

      <div className="mt-4">
        <button
          className="btn btn-light"
          onClick={onBack}
          style={{
            borderRadius: "12px",
            padding: "0.5rem 1.2rem",
            fontSize: "1rem",
          }}
        >
          بازگشت
        </button>
      </div>
    </div>
  );
};

export default JobDetails;
